import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationAssayResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { configurationAssayService } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.service'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'

export const columnsDefAssayGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.externalCode'),
            field: 'externalId',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assay'),
            field: 'name',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.acronym'),
            field: 'code',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.own'),
            field: 'snomed.own',
            minWidth: 80,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.naa'),
            field: 'isNaa',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.snomedCTCode'),
            field: 'snomed.code',
            minWidth: 80,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.subportionType'),
            field: 'subportionType.sptName',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.assayGroup'),
            field: 'assaygroup.name',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationAssaysGridState extends CrudModelPaginator<ConfigurationAssayResponse> {
    service: typeof configurationAssayService
}
export const initialConfigurationAssaysGridState =
    (): ConfigurationAssaysGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.assays.assays',
        columnsDef: columnsDefAssayGrid(),
        datasource: new PaginatorDatasource(configurationAssayService),
        service: configurationAssayService
    })
